import { combineReducers, configureStore } from "@reduxjs/toolkit";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import storage from "redux-persist/lib/storage";
import authSlice from "./redux/authSlice";
import { persistReducer } from "redux-persist";
import scoreSlice from "./redux/scoreSlice";
import homeworkSlice from "./redux/homeWorkSlice";
const reducers = {
    user:authSlice,
    result: scoreSlice,
    homework: homeworkSlice
    }
const persistConfig = {
    key: 'root',
    storage,
    blacklist: ['user'],
    stateReconciler: autoMergeLevel2
}
const rootReducer = combineReducers(reducers);
const persistedReducer = persistReducer(persistConfig,rootReducer)
const configStore= () => (configureStore(
    {reducer:persistedReducer},
    // applyMiddleware()
    ))

export default configStore;
